module.exports = __webpack_public_path__ + "img/20191002133350360截图20191002132645662.a6948c00.jpg";